//import 'react-native-gesture-handler';
import React, { createContext, useContext, useState, Component } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import TelaPerfil from './components/TelaPerfil';
import TelaCarrinho from './components/TelaCarrinho';
import TelaInicio from './components/TelaInicio';
import TelaLogin from './components/TelaLogin';
import TelaEnvio from './components/TelaEnvio';
import TelaCadastro from './components/TelaCadastro';
import TelaEnviado from './components/TelaEnviado';
import TelaVerifica from './components/TelaVerifica';
import TelaSobre from './components/TelaSobre';
import TelaDataEntrega from './components/TelaDataEntrega';
import { AuthContextProvider } from './Contexts/ContextUsuario';
import { ProductsContextProvider } from './Contexts/ContextProdutos';
import firebase from 'firebase';
const Stack = createStackNavigator();



const App = () => {

    return (
      <AuthContextProvider>
      <ProductsContextProvider>
        <NavigationContainer>
        <Stack.Navigator
            screenOptions={{
              headerStyle: {
                height: 60,
              },
            }}>
            <Stack.Screen
            name="VERIFICACAO"
            component={TelaVerifica}
            options={{
              headerStyle: {
                backgroundColor: '#fff',
                height: 0,
              },
              headerTintColor: 'rgba(179, 179, 179, 0)',
              headerTitleStyle: {
                fontWeight: 'normal',
              },
            }}
            />
            <Stack.Screen
              name="LOGIN"
              component={TelaLogin}
              options={{
                headerStyle: {
                  backgroundColor: 'rgba(179, 179, 179, 255)',
                  height: 0,
                },
                headerTintColor: 'rgba(179, 179, 179, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
              }}
            />
            
            <Stack.Screen
              name="PAGINA INICIAL"
              component={TelaInicio}
              options={{
                title: '',
                headerStyle: {
                  backgroundColor: 'rgba(0, 58, 109, 255)',
                  height: 0
                },
                headerTintColor: 'rgba(0, 58, 109, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
              }}
            />
            <Stack.Screen
              name="PERFIL"
              component={TelaPerfil}
              options={{
                title: '',
                headerStyle: {
                  backgroundColor: 'rgba(0, 58, 109, 255)',
                  height: 0
                },
                headerTintColor: 'rgba(0, 58, 109, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
              }}
            />
            <Stack.Screen
              name="CARRINHO"
              component={TelaCarrinho}
              options={{
                title: '',
                headerStyle: {
                  backgroundColor: 'rgba(0, 58, 109, 255)',
                  height: 0
                },
                headerTintColor: 'rgba(0, 58, 109, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
              }}
            />
            <Stack.Screen
              name="CONFIRMAR ENVIO"
              component={TelaEnvio}
              options={{
                title: '',
                headerStyle: {
                  backgroundColor: 'rgba(179, 179, 179, 255)',
                  height: 0
                },
                headerTintColor: 'rgba(179, 179, 179, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
              }}
            />
            <Stack.Screen
              name="SOBRE"
              component={TelaSobre}
              options={{
                title: '',
                headerStyle: {
                  backgroundColor: 'rgba(0, 58, 109, 255)',
                  height: 0
                },
                headerTintColor: 'rgba(0, 58, 109, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
              }}
            />
            <Stack.Screen
              name="CADASTRO"
              component={TelaCadastro}
              options={{
                title: '',
                headerStyle: {
                  backgroundColor: 'rgba(179, 179, 179, 255)',
                  height: 3,
                },
                headerTintColor: 'rgba(179, 179, 179, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
                
              }}
            />
            <Stack.Screen
              name="ENVIADO"
              component={TelaEnviado}
              options={{
                title: '',
                headerStyle: {
                  backgroundColor: 'rgba(179, 179, 179, 255)',
                  height: 0,
                },
                headerTintColor: 'rgba(179, 179, 179, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
              }}
            />
            <Stack.Screen
              name="DATA ENTREGA"
              component={TelaDataEntrega}
              options={{
                title: '',
                headerStyle: {
                  backgroundColor: 'rgba(0, 58, 109, 255)',
                  height: 0,
                },
                headerTintColor: 'rgba(0, 58, 109, 255)',
                headerTitleStyle: {
                  fontWeight: 'normal',
                },
              }}
            />
          </Stack.Navigator>
        </NavigationContainer>
        </ProductsContextProvider>
        </AuthContextProvider>
      
    );
}



export default App;
